import { render, staticRenderFns } from "./NeedHelp.vue?vue&type=template&id=4e281ac2&scoped=true"
import script from "./NeedHelp.vue?vue&type=script&lang=ts"
export * from "./NeedHelp.vue?vue&type=script&lang=ts"
import style0 from "./NeedHelp.vue?vue&type=style&index=0&id=4e281ac2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e281ac2",
  null
  
)

export default component.exports